module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "about-the-author"
    }
  }, [_c('p', {
    staticStyle: {
      "text-align": "center",
      "font-size": "14pt",
      "padding-top": "60px",
      "padding-bottom": "20px"
    }
  }, [_vm._v("About the Author")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em"
    }
  }, [_vm._v("Laurie Brady is a published poet, a writer of short stories, a novelist, and a great dog lover who lives in Sydney, Australia. He has a keen sense of humour, particularly a liking for the ridiculous, and a love of literature and sport. He has spent most of his working life as a teacher and a teacher educator, promoting engaging and quality schooling. He retired recently as professor of education at the University of Technology, Sydney.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0235a5e1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch001.vue
// module id = 63
// module chunks = 0